// extracted by mini-css-extract-plugin
module.exports = {"statContainer":"EnrollmentStats_statContainer__5wPzg","orangeBorder":"EnrollmentStats_orangeBorder__2XdcJ"};